import styled from 'styled-components'
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider'
import type { Props } from './types'

const getTextColor = () => getAutomatedStyleProp('colorOnBackground', 'var(--text-primary)')

export const Container = styled.div<Pick<Props, 'fullWidth'>>`
  position: relative;

  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
`

export const Textarea = styled.textarea<{ $resize: boolean }>`
  width: 100%;
  padding: var(--space-350);
  background: transparent;
  border: 0;
  outline: 0;

  font-size: var(--font-size-400);
  color: ${getTextColor};
  line-height: var(--font-line-height-400);
  vertical-align: top;
  resize: ${({ $resize }) => ($resize ? 'vertical' : 'none')};

  &::placeholder {
    color: ${getAutomatedStyleProp('paleTextColor', 'var(--text-secondary)')};
  }

  :disabled {
    cursor: not-allowed;
  }

  // https://css-tricks.com/snippets/css/change-autocomplete-styles-webkit-browsers/
  &:-webkit-autofill,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:hover {
    -webkit-text-fill-color: ${getTextColor};
    -webkit-background-clip: text;
    caret-color: ${getTextColor};
  }
`

export const Label = styled.label`
  clip: rect(1px, 1px, 1px, 1px);

  position: absolute;
`
